import { makeStyles } from 'tss-react/mui'
import CloseIcon from '@mui/icons-material/Close'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import IconButton from '@mui/material/IconButton'
import genericStyles from 'styles/material-styles/genericStyles.js'
import _colors from '../../../styles/global/_colors'
import { ErrorProps } from '../../../ts/interfaces/errorProps.interface'
import { ThemeType } from '../../../ts/types/theme.types'

const useStyles = makeStyles()((theme: ThemeType) => ({
  error: {
    ...genericStyles.alertContainer,
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.red}`,
    color: `${_colors.redDark}`,
    border: `1px solid ${_colors.red}`,
  },
  icon: {
    marginRight: '15px',
    color: `${_colors.red}`,
  },
  close: {
    marginLeft: '15px',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}))

const ErrorAlert = ({ onClose, description }: ErrorProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.error}>
      <ErrorOutlineOutlinedIcon className={classes.icon} />
      <div>{description}</div>
      <IconButton
        key="close"
        aria-label="Close"
        color="inherit"
        className={classes.close}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default ErrorAlert
